import React from 'react';
import { Icon } from '../../Icons';
import styles from '../AppContent.module.css';
import localStyles from './RecycleBin.module.css';

const deletedItems = [
  { name: 'Bugs.txt', type: 'Text Document', size: '0 KB', deleted: 'Fixed them all!' },
  { name: 'Legacy Code.old', type: 'Old File', size: '999 KB', deleted: 'Time to move on' },
  { name: 'TODO.txt', type: 'Text Document', size: '1 KB', deleted: 'Everything done!' },
  { name: 'node_modules', type: 'Folder', size: '∞ GB', deleted: 'Just npm install again' },
  { name: 'coffee_breaks.log', type: 'Log File', size: '42 KB', deleted: 'Evidence destroyed' },
];

export const RecycleBin: React.FC = () => {
  return (
    <div className={styles.appContainer}>
      <div className={styles.toolbar}>
        <button className={styles.toolbarButton}>Empty Recycle Bin</button>
        <button className={styles.toolbarButton}>Restore All</button>
      </div>

      <div className={localStyles.content}>
        <div className={localStyles.sidebar}>
          <div className={localStyles.sidebarSection}>
            <div className={localStyles.sidebarHeader}>Recycle Bin Tasks</div>
            <div className={localStyles.sidebarItem}>Empty the Recycle Bin</div>
            <div className={localStyles.sidebarItem}>Restore all items</div>
          </div>
        </div>

        <div className={localStyles.main}>
          {deletedItems.length === 0 ? (
            <div className={styles.emptyState}>
              <Icon name="recycle-bin" size={64} />
              <p>The Recycle Bin is empty.</p>
            </div>
          ) : (
            <div className={localStyles.itemList}>
              <div className={localStyles.listHeader}>
                <span className={localStyles.colName}>Name</span>
                <span className={localStyles.colType}>Type</span>
                <span className={localStyles.colSize}>Size</span>
                <span className={localStyles.colReason}>Reason</span>
              </div>
              {deletedItems.map((item, index) => (
                <div key={index} className={localStyles.listItem}>
                  <span className={localStyles.colName}>
                    <Icon name="document" size={16} />
                    {item.name}
                  </span>
                  <span className={localStyles.colType}>{item.type}</span>
                  <span className={localStyles.colSize}>{item.size}</span>
                  <span className={localStyles.colReason}>{item.deleted}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className={styles.statusBar}>
        {deletedItems.length} items | Ready for permanent deletion (just kidding!)
      </div>
    </div>
  );
};

export default RecycleBin;
